module.exports = __webpack_public_path__ + "components/nearby-points/static/photo-10-ca177ccb0e5e411acafa1721e50bb2ab.jpg";